import React from 'react';
import toastr from 'toastr';

import Loading from '../../shared/loading';
import parseFailXhr from '../../shared/parse-fail-xhr';
import Pagination from '../../shared/pagination';
import ErrorBoundary from '../../shared/error-boundary';
import { getLocationState } from '../../shared/location';
import NotificationItem from './notification-item';
import Notification from './notification';
import { getPaginated } from '../../services/notifications-service';

const NOTIFICATIONS_PER_PAGE = 30;
const PAGE_URL = '/profiles/me/notifications';

export default class NotificationsTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      notifications: [],
      page: 1,
      totalPageCount: 1,
      anonymousNotificationsEnabled: false,
    };
  }

  componentDidMount() {
    const locationState = getLocationState();
    const page = +locationState.p || this.state.page;

    this.startSpinners();

    getPaginated(page, NOTIFICATIONS_PER_PAGE)
      .then(result => this.setState({
        page,
        notifications: result.data.notifications.map(n => new Notification(n)),
        totalPageCount: result.data.total_page_count,
        anonymousNotificationsEnabled: result.data.anonymous_notifications_enabled,
      }))
      .catch(e => {
        const errors = parseFailXhr(e.jqXHR);
        if (errors.anyUnhandledErrors()) {
          toastr.error(errors.getErrorSummary(), 'Error loading notifications');
        }
      })
      .finally(() => this.stopSpinners());
  }

  startSpinners() {
    this.notificationsSpinner.start();
    this.topPagination.spinner.start();
  }

  stopSpinners() {
    this.notificationsSpinner.stop();
    this.topPagination.spinner.stop();
  }

  renderNotifications() {
    return this.state.notifications.map(n => (
      <NotificationItem
        notification={n}
        key={n.id}
        anonymousNotificationsEnabled={this.state.anonymousNotificationsEnabled}
      />
    ));
  }

  render() {
    const { totalPageCount, page } = this.state;
    const paginationOpts = { totalPageCount, page, pageUrl: PAGE_URL };

    return (
      <ErrorBoundary>
        <div className="notifications-table">
          <header className="page-header">
            <Pagination ref={x => (this.topPagination = x)} {...paginationOpts} />
            <h1><span>Notifications</span></h1>
          </header>
          <Loading ref={x => (this.notificationsSpinner = x)}>
            <section className="notifications">
              {!!this.state.notifications.length || (
                <div className="alert alert-info" role="alert">
                  You have no notifications
                </div>
              )}
              {!!this.state.notifications.length && this.renderNotifications()}
            </section>
            <Pagination {...paginationOpts} />
          </Loading>
        </div>
      </ErrorBoundary>
    );
  }
}
